import { OnboardingProfileDto } from './onboarding-profile.dto';

/** The trial starts without a card: completing onboarding sends only the registry profile. */
export class CompleteOnboardingDto extends OnboardingProfileDto {}
